export default "__VITE_ASSET__CJg481fY__"